import React, { Component, ErrorInfo, ReactNode } from 'react';
import ErrorView from 'components/ErrorView';
import Sentry from 'libs/sentry';

interface IProp {
  children: ReactNode;
}

interface IState {
  hasError: boolean;
}

class ErrorBoundary extends Component<IProp, IState> {
  constructor(props: IProp) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    Sentry?.captureException?.(error, { extra: { ...errorInfo } });
  }

  reloadPage() {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorView
          title="Something went wrong."
          message="Please reload the page to continue."
          actionTitle="Reload page"
          onClick={this.reloadPage}
        />
      );
    }

    // Normally, just render children
    return this.props.children;
  }
}

export default ErrorBoundary;
